'use-client';
import * as React from 'react';
import type { CollageProps } from '../Collage.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Collage: React.FC<CollageProps> = props => {
  return <TPAGallery {...props}></TPAGallery>;
};

export default Collage;
